import script from "./Article.vue?vue&type=script&lang=ts&setup=true"
export * from "./Article.vue?vue&type=script&lang=ts&setup=true"

import "./Article.vue?vue&type=style&index=0&id=3066ea77&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3066ea77"]])

export default __exports__